import { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { AppContext } from "../../../appContext/AppContext";
import CustomIconButton from "../../../component/custom-icon-button/CustomIconButton";
import FilterSidebar from "../../../component/filter-sidebar/FilterSidebar";
import LazyLoadTable from "../../../component/lazy-load-table/LazyLoadTable";
import { getPaymentDetail } from "../../../phan-he-vien-phi/services/PhanHeVienPhiServices";
import {
  CODE,
  DEFAULT_PAGE_INDEX,
  DEFAULT_PAGE_SIZE,
  ID_DANG_KY_KHAM,
  KEY_DS_DANH_MUC_TIEP_DON,
  LEVEL,
  LOAI_PHONG,
  MODULE_TYPE,
  RESPONSE_MESSAGE,
  SEARCH_OBJECT_MAX_SIZE,
} from "../../../utils/Constant";
import {
  customTrangThaiBenhNhan,
  formatDateToYYYYMMDD,
  formatTrangThaiBenhNhan,
} from "../../../utils/FormatUtils";
import WfStatusSummary from "../../../workflows/components/WfStatusSummary";
import { WfConstTracker } from "../../../workflows/Constant";
import { WfSummaryStatusRes } from "../../../workflows/models/WfWorkflows";
import { PhanHeTiepDonContext } from "../../contexts/PhanHeTiepDonContext";
import ModalKhamKetHop from "../../modals/modal-kham-ket-hop/ModalKhamKetHop";
import { IBenhNhan } from "../../models/DSBenhNhanKhamBenhModels";
import {
  getDSKhamBenh,
  getDSTrangThai,
  getThongTinKhamBenh,
  inBangKeChiPhiKhamBenh,
  inGiayNghiOm,
  inPhieuChiDinhChuaThanhToan,
  inPhieuChuyenTuyen,
} from "../../services/PrintExportService";
import ButtonIn from "../../../component/button-in-phieu";
import ModalThongTinNghiOm from "../modal-tt-nghi-om/ModalThonTinNghiOm";
import { OctAutocomplete } from "@oceantech/oceantech-ui";
import ContextMenu from "../../../component/ContextMenuV3";
import { IContextMenu } from "../../../phan-he-tiep-nhan-thanh-toan/models/ModelTabDSDangKy";
import { WF_STATUS } from "../../../phan-he-kham-doan/constants/PhanHeKhamDoan";
import WfButton from "../../../workflows/components/WfButton";
import DynamicComponentKB from "../DynamicComponentKB";
import { getDepartmentsByModule } from "../../../utils/ServicesUtils";
import { KEY_LOCALSTORAGE } from "../../../auth/core/_consts";
import { localStorageItem } from "../../../utils/LocalStorage";
import { useSpeechStream } from "../../../utils/SpeechStream";
import { usePhanHeDieuTriNoiTruContext } from "../../../phan-he-noi-tru-dieu-tri/PhanHeDieuTriContext";
import PatientRowData from "../../../component/patient-row-data";
import { changeVisitType } from "../../services/KhamBenhService";
import { IDanhSachDanhMuc } from "../../../phan-he-tiep-nhan-thanh-toan/models/TiepDonModel";
import { getIndexedDBItem } from "../../../utils/IndexedDB";
import DepartmentFilter from "../department-filter/DepartmentFilter";

const TableDsBenhNhanKhamBenh = (props: any) => {
  const {
    setBenhNhanInfo,
    benhNhanInfo,
    setThongTinChiPhi,
    statusChangedEventFunc,
  } = useContext(PhanHeTiepDonContext);

  const { setBenhNhanDieuTri } = usePhanHeDieuTriNoiTruContext();

  const { filter, setFilter } = props;
  const { setIsLoading } = useContext(AppContext);

  const [selectedBenhNhan, setSelectedBenhNhan] = useState<any>();
  const [summaryStatus, setSummaryStatus] = useState<WfSummaryStatusRes[]>([]);
  const [shouldOpenKhamKetHop, setShouldOpenKhamKetHop] =
    useState<boolean>(false);
  
  const [shouldOpenTTNghiOm, setShouldOpenTTNghiOm] =
    useState<boolean>(false);
  const [searchObject, setSearchObject] = useState<any>(null);
  const [rowSeclectedByContextMenu, setRowSeclectedByContextMenu] = useState<any>();
  const [contextMenu, setContextMenu] = useState<null | {
    x: number;
    y: number;
  }>(null);
  let componentName = "TableDsBenhNhanKhamBenh";
  const [dataDynamic, setDataDynamic] = useState<any>();
  const { startSpeechStream } = useSpeechStream();
  const [danhSachDanhMuc, setDanhSachDanhMuc] = useState<any>();
  const [totalRows, setTotalRows] = useState(0);

  const accessTokenDecode = localStorageItem.get(KEY_LOCALSTORAGE.ACCESS_TOKEN_DECODE);
  const speakerConfig = localStorageItem.get(KEY_LOCALSTORAGE.SPEAKER_CONFIG);

  useEffect(() => {
    filter &&
      setSearchObject({
        keyword: filter?.keyword || null,
        filter: filter?.formal?.id || 0,
        sortDirection: filter?.order?.id || null,
        fromDate: formatDateToYYYYMMDD(filter?.period?.fromDate) || null,
        toDate: formatDateToYYYYMMDD(filter?.period?.toDate) || null,
        color: filter?.status?.color || null,
        fulfillDeptCode: filter?.fulfillDeptCode || null,
      });
  }, [filter]);

  const updateTrangThai = async (filter?: any) => {
    setIsLoading(true);
    const searchObject = SEARCH_OBJECT_MAX_SIZE;
    const DEFAULT_FORMAL = 0;
    try {
      let { data } = await getDSTrangThai({
        ...searchObject,
        keyword: filter?.keyword || null,
        filter: filter?.formal?.id || DEFAULT_FORMAL,
        sortDirection: filter?.order?.id || null,
        fromDate: formatDateToYYYYMMDD(filter?.period?.fromDate) || null,
        toDate: formatDateToYYYYMMDD(filter?.period?.toDate) || null,
        color: filter?.status?.color || null,
        fulfillDeptCode: filter?.fulfillDeptCode,
      });
      if (data?.code === CODE.SUCCESS) {
        let newListStatus = data?.data || [];
        setSummaryStatus(newListStatus);
      } else {
        toast.warning(RESPONSE_MESSAGE.ERROR);
      }
      setIsLoading(false);
    } catch (e) {
      toast.error(RESPONSE_MESSAGE.ERROR);
      setIsLoading(false);
    }
  };

  const handleGetDsDanhMuc = async () => {
    try {
      const responseDsDanhmuc: IDanhSachDanhMuc = await getIndexedDBItem(
        KEY_DS_DANH_MUC_TIEP_DON
      );
      setDanhSachDanhMuc(responseDsDanhmuc);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    handleGetDsDanhMuc();
  }, []);

  useEffect(() => {
    filter && updateTrangThai(filter);
  }, [props.statusChangedEvent, filter]);

  useEffect(() => {
    if (selectedBenhNhan) {
      const { treatment } = selectedBenhNhan;
      handleGetThongTinKhamBenh(selectedBenhNhan);
      setBenhNhanDieuTri({
          ...selectedBenhNhan,
          treatmentId: treatment?.treatmentId,
          medicalRecordCode: treatment?.medicalRecordCode,
          medicalRecordId: treatment?.medicalRecordId,
          recordTypeCode: treatment?.recordTypeCode,
          recordTypeName: treatment?.recordTypeName,
      });
    }
  }, [selectedBenhNhan, benhNhanInfo?.shouldUpdate]);

  const handleGetThongTinKhamBenh = async (dataBenhNhan: any) => {
    try {
      let visitId = dataBenhNhan?.visitId;
      let orderId = dataBenhNhan?.orderId;

      setIsLoading(true);
      if (visitId && orderId) {
        let { data } = await getThongTinKhamBenh({
          visitId,
          orderId,
        });
        let { data: dataChiPhi } = await getPaymentDetail(visitId);
        if (CODE.SUCCESS === dataChiPhi?.code) {
          setThongTinChiPhi({
            ...dataChiPhi?.data,
            ttDiscount:
              dataChiPhi?.data?.ttDiscountInv +
              dataChiPhi?.data?.ttDiscountPercent,
          });
        }
        if (CODE.SUCCESS === data?.code) {
          setBenhNhanInfo({
            ...benhNhanInfo,
            isKhamBenh: false,
            isExamined: false,
            thongTinKhamBenh: {
              ...benhNhanInfo?.thongTinKhamBenh,
              ...data?.data,
              ...dataBenhNhan,
              isConclusion: data?.data?.isConclusion,
            },
          });
        }
      } else {
        setBenhNhanInfo({
          ...benhNhanInfo,
          isKhamBenh: false,
          isExamined: false,
          thongTinKhamBenh: {},
        });
      }
    } catch (error) {
      toast.warning("Xảy ra lỗi, vui lòng thử lại!");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSelectedBenhNhan = async (benhNhans: IBenhNhan[]) => {
    setSelectedBenhNhan(benhNhans[0]);
  };

  const handleClickAction = async (currStatusCode: any, rowData: any, listResponse: any) => {
    try {
      setIsLoading(true);
      if(currStatusCode === WF_STATUS.CHUA_KHAM.CODE) {
        setBenhNhanInfo({
          ...benhNhanInfo,
          thongTinKhamBenh: {
            ...benhNhanInfo?.thongTinKhamBenh,
            isMedicalExamStarted: false,
          },
        });
      }
      else if(currStatusCode === WF_STATUS.DANG_KHAM.CODE) {
        setBenhNhanInfo({
          ...benhNhanInfo,
          thongTinKhamBenh: {
            ...benhNhanInfo?.thongTinKhamBenh,
            isExamined: listResponse?.isExamined,
            encounter: listResponse?.encounter,
            encounterDiagnosis: listResponse?.encounterDiagnosis,
          },
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }

  const doSearch = (data: any) => {
    setFilter({
      ...filter,
      ...data,
    });
  };

  const handleSearchByStatus = (status: WfSummaryStatusRes) => {
    let dataFilter = { ...filter, status };
    setFilter(dataFilter);
  };

  const handleGoiBN = (data: any) => {
    if (!speakerConfig?.speaker) {
      toast.warning("Không tìm thấy cấu hình phát loa");
      return;
    }
    let stt = data?.ordinalNumber;
    let name = data?.name;
    let diaDiem = data?.fulfillDeptName;
    if (stt && diaDiem) {
      let { spkApi, spkPath1, spkPath2, spkPath3 } = speakerConfig.speaker;
      let content = `${spkPath1}, ${name} , ${spkPath2}, ${stt}, ${spkPath3}, ${diaDiem}`;
      startSpeechStream({
        url: spkApi,
        content,
      });
    } else {
      toast.warning("Bệnh nhân không đủ thông tin");
    }
  };

  const handleDKKhamCapCuu = async (row: any) => {
    try {
      let visitId = row?.visitId;
      let emergencyValue = danhSachDanhMuc?.listDKKham?.find((item: any) => item?.id === ID_DANG_KY_KHAM.CAP_CUU);
      let { data } = await changeVisitType({
        visitTypeId: emergencyValue?.id,
        visitTypeName: emergencyValue?.name,
      }, visitId);
      if (CODE.SUCCESS === data?.code) {
        statusChangedEventFunc?.();
        toast.success(RESPONSE_MESSAGE.SUCCESS);
      } else {
        toast.error(RESPONSE_MESSAGE.ERROR);
      }
    } catch (error) {
      console.error(error);
      toast.error(RESPONSE_MESSAGE.ERROR);
    }
  }

  const handleContextMenu = (e: any, row: any) => {
    setRowSeclectedByContextMenu(row);
    setContextMenu({ x: e.clientX, y: e.clientY });
  };

  const handleClickOptionContextMenu = (value: any) => {
    const menuActions = {
      [CODE_MENU.GOI_BN]: () => handleGoiBN(rowSeclectedByContextMenu),
      [CODE_MENU.CAP_CUU]: () => handleDKKhamCapCuu(rowSeclectedByContextMenu),
    };
    menuActions[value?.code]?.();
    setContextMenu(null);
  };

  const actionClick = (data: any) => {
    setDataDynamic({ ...data });
  };
  const CODE_MENU = {
    GOI_BN: "goiBn",
    CAP_CUU: "capCuu",
  };

  const dropListChiDinhDichVu: IContextMenu[] = [
    {
      title: "Khám bệnh",
    },
    {
      icon: <i className="bi bi-volume-up-fill text-pri"></i>,
      code: CODE_MENU.GOI_BN,
      name: "Gọi bệnh nhân",
    },
    ...((
      rowSeclectedByContextMenu?.visitTypeId !== ID_DANG_KY_KHAM.CAP_CUU
      && !rowSeclectedByContextMenu?.isConclusion
    ) ? [
      {
        icon: <i className="bi bi-exclamation-diamond-fill text-danger"></i>,
        code: CODE_MENU.CAP_CUU,
        name: "Cấp cứu",
      }
    ] : []),
  ];

  const LIST_FORMAL = [
    {
      id: 4,
      value: "stt",
      name: "STT",
    },
    {
      id: 2,
      value: "hoTen",
      name: "Họ tên",
    },
    {
      id: 3,
      value: "tuoi",
      name: "Tuổi",
    },
    {
      id: 1,
      value: "maBenhNhan",
      name: "Mã BN",
    },
  ];

  const DROP_LIST_PHIEU_IN = [
    {
      id: 1,
      button: <ButtonIn
        label="Bảng kê chi phí khám chữa bệnh"
        fetchExport={inBangKeChiPhiKhamBenh}
        params={{
          visitId: benhNhanInfo?.thongTinKhamBenh?.visitId,
        }}
        isOnlyText
      />
    },
    {
      id: 2,
      button: <ButtonIn
        label="Giấy nghỉ ốm"
        fetchExport={inGiayNghiOm}
        params={{
          orderId: benhNhanInfo?.thongTinKhamBenh?.orderId,
        }}
        isOnlyText
      />
    },
    {
      id: 3,
      button: <span
        onClick={() => setShouldOpenTTNghiOm(true)}
      >Thông tin nghỉ ốm</span>
    },
    {
      id: 4,
      button: <ButtonIn
        label="Phiếu chỉ định chưa thanh toán"
        fetchExport={inPhieuChiDinhChuaThanhToan}
        params={{
          orderId: benhNhanInfo?.thongTinKhamBenh?.orderId,
        }}
        isOnlyText
      />
    },
    {
      id: 5,
      button: <ButtonIn
        label="Giấy chuyển tuyến"
        fetchExport={inPhieuChuyenTuyen}
        params={{
          orderId: benhNhanInfo?.thongTinKhamBenh?.orderId,
        }}
        isOnlyText
      />
    },
  ];
  
  const columns = [
    {
      name: "TT",
      field: "",
      headerStyle: {
        maxWidth: "35px",
      },
      render: (rowData: any, index: number) => {
        const { combined, component, color } = rowData || {};
        const iconType = combined
          ? component
            ? "plus-circle"
            : "arrow-right-circle"
          : null;

        return iconType
          ? customTrangThaiBenhNhan(color, iconType)
          : formatTrangThaiBenhNhan(color);
      },
    },
    {
      name: "STT",
      field: "",
      headerStyle: {
        maxWidth: "40px",
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (rowData: any, index: number) => <span className="text-system">{rowData?.ordinalNumber || ""}</span>,
    },
    {
      name: "Tên bệnh nhân",
      field: "",
      headerStyle: {
        minWidth: "175px",
      },
      cellStyle: {
        maxWidth: "200px",
      },
      render: (rowData: any, index: number) => {
        return (
          <PatientRowData 
            data={{
              ...rowData,
              patientName: rowData?.name,
              patientCode: rowData?.code,
              visitObjectTypeName: rowData?.objectTypeName,
            }}
          />
        )
      },
    },
    {
      name: "Thao tác",
      field: "",
      headerStyle: {
        width: "70px",
      },
      render: (rowData: any, index: number) => {
				return (
					<div className="d-flex justify-content-center">
						<div
							className="flex"
							onClick={(e) => { 
								e.stopPropagation();
							}}
						>
							<WfButton
								workflowList={{
									nextStatuses: rowData?.nextStatuses,
								}}
								tracker={WfConstTracker.CLINICAL}
								objectId={rowData?.orderId}
								additionalFunc={(codeRequest, codeBtn, listResponse) => {
									handleSelectedBenhNhan([rowData]);
									handleClickAction(codeRequest, rowData, listResponse);
									statusChangedEventFunc?.();
								}}
								additionalProps={{
									patientId: rowData?.patientId,
									visitId: rowData?.visitId,
									providerId: accessTokenDecode?.pid,
									orderId: rowData?.orderId,
								}}
								handleClick={(data) => {
                  handleSelectedBenhNhan([rowData]);
                  actionClick(data);
                }}
								componentName={componentName}
							/>
						</div>

						{rowData?.isAllowCombined && (
							<CustomIconButton
								variant="delete"
								title="Khám kết hợp"
								onClick={() => {
									setShouldOpenKhamKetHop(true);
								}}
							>
								<i className="bi bi-plus-square-fill text-success"></i>
							</CustomIconButton>
						)}
					</div>
				);
			},
    },
  ];
 
  return (
		<>
			<FilterSidebar
				title="Danh sách"
				formalList={LIST_FORMAL}
				onSearch={doSearch}
				listMenuItem={[]}
				handleSelectOption={() => {}}
				isShowMenuItem={false}
				roomTypeHasPendingScreen={LOAI_PHONG.PHONG_KHAM_BENH}
			/>
			<div className="d-flex flex-column h-100 pt-3">
				<div className="spaces h-calc-vh-345">
					<LazyLoadTable
						columns={columns}
						axiosReq={getDSKhamBenh}
						searchData={searchObject}
						urlData="data.data.medicalExamBrief"
						className="spaces h-calc-vh-354"
						onRowClick={(rowData) => handleSelectedBenhNhan([rowData])}
						handleContextMenu={handleContextMenu}
						dependencies={[props.statusChangedEvent]}
						rowSeclected={selectedBenhNhan}
						rowKey="orderId"
            allowReselectOnUpdate
            onLoadDataSuccess={(response) => {
              setTotalRows(response.data.total);
            }}
					/>
				</div>
				<div className="spaces px-12">
          <strong className="spaces pt-7">Tổng số bệnh nhân: {totalRows}</strong>
          <DepartmentFilter 
            value={filter?.fulfillDeptCode}
            onChange={(option) => {
							doSearch({
								...filter,
								fulfillDeptCode: option?.code,
							});
						}}
            params={{ type: LOAI_PHONG.PHONG_KHAM_BENH}}
            moduleType="outpatient"
          />
				</div>
				<WfStatusSummary summaryStatus={summaryStatus} onClick={handleSearchByStatus} />

				{shouldOpenKhamKetHop && (
					<ModalKhamKetHop
						open={shouldOpenKhamKetHop}
						handleClose={() => {
							setShouldOpenKhamKetHop(false);
						}}
						patientSelectedRow={selectedBenhNhan}
					/>
				)}

				{dataDynamic && (
					<DynamicComponentKB
						data={dataDynamic}
						setData={setDataDynamic}
						onConfirm={() => {}}
					/>
				)}
				{shouldOpenTTNghiOm && (
					<ModalThongTinNghiOm
						handleCloseModal={() => {
							setShouldOpenTTNghiOm(false);
						}}
					/>
				)}
				{contextMenu && (
					<ContextMenu
						handleClickOptionContextMenu={handleClickOptionContextMenu}
						handleCloseMenu={() => setContextMenu(null)}
						data={dropListChiDinhDichVu}
						target={contextMenu}
					/>
				)}
			</div>
		</>
  );
};

export default TableDsBenhNhanKhamBenh;
